import { render, staticRenderFns } from "./ForumChatThreadCardBody.vue?vue&type=template&id=17d358e6&scoped=true"
import script from "./ForumChatThreadCardBody.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardBody.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardBody.vue?vue&type=style&index=0&id=17d358e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d358e6",
  null
  
)

export default component.exports